import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  padding-inline: 20px;
`;

const Row = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 15px;

  &:last-child {
    padding-bottom: 15px;
  }
`;

const Item = styled.div<{ itemWidth?: number; itemHeight?: number }>`
  width: ${(props) => props.itemWidth ?? 109}px;
  height: ${(props) => props.itemHeight ?? 65}px;
  margin-right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 2px 2px 20px 2px rgba(0, 0, 0, 0.1);
  padding: 10px;

  &:last-child {
    margin-right: 0px;
  }
`;

interface PyramidGridProps<ItemProps> {
  items: ItemProps[];
  numRows: number;
  maxItemsAtBase: number;
  renderItem: (item: ItemProps) => React.ReactNode;
  itemWidth?: number;
  itemHeight?: number;
}

const PyramidGrid = <T,>({
  numRows,
  maxItemsAtBase,
  items,
  renderItem,
  itemWidth,
  itemHeight,
}: PyramidGridProps<T>) => {
  const rows = [];
  let itemIndex = 0;
  for (let i = 1; i <= numRows; i++) {
    const rowItems = [];
    const numItemsInRow = Math.min(
      maxItemsAtBase - Math.abs(numRows - i),
      items.length - itemIndex
    );
    for (let j = 0; j < numItemsInRow; j++) {
      rowItems.push(
        <Item itemWidth={itemWidth} itemHeight={itemHeight}>
          {renderItem(items[itemIndex])}
        </Item>
      );
      itemIndex++;
    }
    rows.push(<Row key={i}>{rowItems}</Row>);
  }

  return <Container>{rows}</Container>;
};

export default PyramidGrid;
